import React from "react";
import { useTranslation } from "react-i18next";

import './chatExpert.scss'

const ChatExpert = () => {
    const { t } = useTranslation()
    return (
        <div className="container-chatbot-expert">
            <div className="texts-chatbot-expert">
                <h1>{t("chat.chat_expert.title")}</h1>
                <p>{t("chat.chat_expert.section_text_1")}</p>
                <p>{t("chat.chat_expert.section_text_2")}</p>
            </div>
        </div>
    )
}


export default ChatExpert